import MiniSearch from 'minisearch'
import { docsSections } from '../../docs/routes/_config'

let miniSearch

const getSectionPages = (section) => {
  if (Array.isArray(section.groups)) {
    return section.groups.flatMap((group) => {
      if (group.component) {
        return [
          {
            ...group,
            groupId: null,
            groupTitle: null,
          },
        ]
      }

      return Array.isArray(group.pages)
        ? group.pages.map((page) => ({
            ...page,
            groupId: group.id,
            groupTitle: group.title,
          }))
        : []
    })
  }

  return Array.isArray(section.pages) ? section.pages : []
}

export function getDocsIndex() {
  if (miniSearch) return miniSearch

  const docs = []

  docsSections.forEach((section) => {
    getSectionPages(section).forEach((page) => {
      docs.push({
        id: `${section.id}/${page.id}`,
        pageId: page.id,
        title: page.title,
        summary: page.summary,
        tags: (page.tags || []).join(' '),
        section: section.title,
        sectionID: section.id,
        group: page.groupTitle || '',
      })
    })
  })

  miniSearch = new MiniSearch({
    fields: ['title', 'summary', 'tags', 'section', 'group'],
    storeFields: [
      'title',
      'summary',
      'section',
      'pageId',
      'sectionID',
      'group',
    ],
  })

  miniSearch.addAll(docs)

  return miniSearch
}
